import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useLocation, Navigate} from "react-router-dom";

import {APIS} from '../../config/apis';
import {APPCONFIG} from '../../app.config';
import {useForm, useFormErrors, useNav, useUnsavedChangesGuard, useReporte} from '../../components/hooks';
import { ALERT_TYPE, CUENTA_STATE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../consts/validationMessage';
import {ServerRequest} from '../../utils/apiweb';

import {Loading, MessageModal, SectionHeading, SectionSidebar} from '../../components/common';
import {getDateId} from '../../utils/convert';
import {CloneObject,OpenObjectURL} from '../../utils/helpers';
import {MenuLateral, SectionForm} from './components';
import {
    AddInmueble,
    buildInmuebleEntityInit,
    FindInmueble,
    MakeListDomiciliosRelacionados,
    ModifyBajaCuenta,
    ModifyInmueble,
    UpdateEntityRow
} from './utils';
import {FooterButtonVolver} from '../../components/buttons/FooterButtonVolver/FooterButtonVolver';
import {PERMISSIONS} from "../../consts/permissions";

function InmuebleView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const previousFilters = location.state?.filters;

    //#region Variables
    const entityInit = buildInmuebleEntityInit();
    const menuesInit = {
        obras: false,
        expedientes: false,
        certificadosEscribanos: false,
        relacionesCuentas: false,
        controladoresCuentas: false,
        zonasEntrega: false,
        valuaciones: false,
        edesur: false,
        catastro: false,
        aplicacionCreditos: false,
        condonacion: false,
        pagosAnticipados: false,
        planesPago: false,
        liquidaciones: false
    };
    //#endregion

    //#region Hooks
    const navigate = useNav()

    const [state, setState] = useState({
        processKey: `Inmueble_${params.id ?? 0}_${getDateId()}`,
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        menues: menuesInit,
        showMenu: false,
        tabActive: "terreno"
    });

    const [toggledSidebarLeft, setToggledSidebarLeft] = useState(true);
    const [pendingChange, setPendingChange] = useState(state.mode === OPERATION_MODE.NEW);
    const [message, setMessage] = useState({show: false, text: "", callback: null, id: 0});

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);
    const navigateAllowed = (navOptions) => {
        allowNavigation();
        navigate(navOptions);
    };

    const mount = () => {
        // alta obsoleta: en modo NEW el guard redirige a la grilla, no inicializar ni avisar
        if (state.mode === OPERATION_MODE.NEW) return;
        if (state.id > 0) {
            FindInmueble(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindInmueble);
        } else {
            dispatch(dataTaggerActionSet(state.processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Ingrese los datos y presione siguiente para confirmar el alta');
        }
    }
    useEffect(mount, []);

    const [listExpedientes, setListExpedientes] = useState([]);

    const updateListExpedientes = () => {
        var list = []
        const listsWithExpediente = [
            ...state.entity.recargosDescuentos,
            ...state.entity.obrasInmueble
        ];
        listsWithExpediente.filter(f => f.state !== 'r').forEach(x => {
            if (x.idExpediente && x.idExpediente > 0 && list.indexOf(x.idExpediente) === -1) list.push(x.idExpediente)
        });

        setListExpedientes(list);
    }

    useEffect(updateListExpedientes, [state.entity.recargosDescuentos, state.entity.obrasInmueble]);


    const [listDireccionesRelacionadas, setListDireccionesRelacionadas] = useState([]);
    const updateListDireccionesRelacionadas = () => {
        MakeListDomiciliosRelacionados(state.entity.vinculosInmueble, state.entity.ladosTerreno)
            .then(list => {
                setListDireccionesRelacionadas(list);
            })
            .catch((error) => {
                const message = `Error consultando domicilios: ${error.message}`;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            });
    }

    useEffect(updateListDireccionesRelacionadas, [state.entity.vinculosInmueble, state.entity.ladosTerreno]);


    const [inmueble_formValues, inmueble_formHandle, , inmueble_formSet] = useForm({
        idEstadoCarga: 20,
        catastralCir: '',
        catastralSec: '',
        catastralChacra: '',
        catastralLchacra: '',
        catastralQuinta: '',
        catastralLquinta: '',
        catastralFrac: '',
        catastralLfrac: '',
        catastralManz: '',
        catastralLmanz: '',
        catastralParc: '',
        catastralLparc: '',
        catastralSubparc: '',
        catastralUfunc: '',
        catastralUcomp: '',
        catastralRtasPrv: '',
        tributoManz: '',
        tributoLote: '',
        tributoEsquina: false,
        catastralCodigo: '',
        catastralPartido: ''
    }, 'inmueble_');

    const [cuenta_formValues, cuenta_formHandle, , cuenta_formSet] = useForm({
        numeroCuenta: '',
        numeroWeb: ''
    }, 'cuenta_');

    const [estadoOpen, setEstadoOpen] = useState(false);
    const { errorOf, validate } = useFormErrors(getErrors);
    //#endregion

    //#region Handles
    const cuenta_formHandleProxy = (event) => {
        cuenta_formHandle(event);
        setPendingChange(true);
    }
    const inmueble_formHandleProxy = (event) => {
        inmueble_formHandle(event);
        setPendingChange(true);
    }
    const handleClickGuardar = () => {
        if (getErrors().idEstadoCarga) setEstadoOpen(true);
        if (!validate()) return;

        if (state.id === 0) {
            AddInmueble(state, setState, inmueble_formValues, cuenta_formValues, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError)
        } else {
            ModifyInmueble(state, setState, dataTagger, inmueble_formValues, cuenta_formValues, dispatch, dataTaggerActionClear, callbackNoSuccess, callbackError, callbackSuccessFindInmueble);
        }
    }
    const handleClickBaja = () => {
        const idCuenta = state.entity.cuenta.id
        setMessage({
            show: true,
            text: "Al aceptar el cambio se procederá con la baja de la cuenta.",
            callback: () => ModifyBajaCuenta(idCuenta, state, setState, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError),
            id: idCuenta
        });
    }
    //#endregion

    //#region Callback
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindInmueble = (response) => {
        response.json()
            .then((data) => {

                //deserialize date fields
                if (data.inmueble.fechaCargaInicio) data.inmueble.fechaCargaInicio = new Date(data.inmueble.fechaCargaInicio);
                if (data.inmueble.fechaCargaFin) data.inmueble.fechaCargaFin = new Date(data.inmueble.fechaCargaFin);
                if (data.cuenta.fechaAlta) data.cuenta.fechaAlta = new Date(data.cuenta.fechaAlta);
                if (data.cuenta.fechaBaja) data.cuenta.fechaBaja = new Date(data.cuenta.fechaBaja);

                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.variablesCuenta.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.ladosTerreno.forEach(x => {
                    x.ladosTerrenoServicio.forEach(x2 => {
                        if (x2.fechaDesde) x2.fechaDesde = new Date(x2.fechaDesde);
                        if (x2.fechaHasta) x2.fechaHasta = new Date(x2.fechaHasta);
                    });
                });
                data.ladosTerreno.forEach(x => {
                    x.ladosTerrenoObra.forEach(x2 => {
                        if (x2.fecha) x2.fecha = new Date(x2.fecha);
                    });
                });
                data.vinculosInmueble.forEach(x => {
                    if (x.fechaInstrumentoDesde) x.fechaInstrumentoDesde = new Date(x.fechaInstrumentoDesde);
                    if (x.fechaInstrumentoHasta) x.fechaInstrumentoHasta = new Date(x.fechaInstrumentoHasta);
                });
                data.controladoresCuentas.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.obrasInmueble.forEach(x => {
                    if (x.fechaPrimerVencimiento) x.fechaPrimerVencimiento = new Date(x.fechaPrimerVencimiento);
                    if (x.fechaSegundoVencimiento) x.fechaSegundoVencimiento = new Date(x.fechaSegundoVencimiento);
                    if (x.fechaPresentacion) x.fechaPresentacion = new Date(x.fechaPresentacion);
                    if (x.fechaInspeccion) x.fechaInspeccion = new Date(x.fechaInspeccion);
                    if (x.fechaAprobacion) x.fechaAprobacion = new Date(x.fechaAprobacion);
                    if (x.fechaInicioDesglose) x.fechaInicioDesglose = new Date(x.fechaInicioDesglose);
                    if (x.fechaFinDesglose) x.fechaFinDesglose = new Date(x.fechaFinDesglose);
                    if (x.fechaFinObra) x.fechaFinObra = new Date(x.fechaFinObra);
                    if (x.fechaArchivado) x.fechaArchivado = new Date(x.fechaArchivado);
                    if (x.fechaIntimado) x.fechaIntimado = new Date(x.fechaIntimado);
                    if (x.fechaVencidoIntimado) x.fechaVencidoIntimado = new Date(x.fechaVencidoIntimado);
                    if (x.fechaMoratoria) x.fechaMoratoria = new Date(x.fechaMoratoria);
                    if (x.fechaVencidoMoratoria) x.fechaVencidoMoratoria = new Date(x.fechaVencidoMoratoria);
                });
                data.condicionesEspeciales.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.superficies.forEach(x => {
                    if (x.fechaIntimacion) x.fechaIntimacion = new Date(x.fechaIntimacion);
                    if (x.fechaPresentacion) x.fechaPresentacion = new Date(x.fechaPresentacion);
                    if (x.fechaVigenteDesde) x.fechaVigenteDesde = new Date(x.fechaVigenteDesde);
                    if (x.fechaRegistrado) x.fechaRegistrado = new Date(x.fechaRegistrado);
                    if (x.fechaPermisoProvisorio) x.fechaPermisoProvisorio = new Date(x.fechaPermisoProvisorio);
                    if (x.fechaAprobacion) x.fechaAprobacion = new Date(x.fechaAprobacion);
                    if (x.fechaFinObra) x.fechaFinObra = new Date(x.fechaFinObra);
                });
                data.edesur.forEach(x => {
                    if (x.fechaDesdeCliente) x.fechaDesdeCliente = new Date(x.fechaDesdeCliente);
                    if (x.fechaHastaCliente) x.fechaHastaCliente = new Date(x.fechaHastaCliente);
                    x.edesurClientes.forEach(x2 => {
                        if (x2.fechaDesde) x2.fechaDesde = new Date(x2.fechaDesde);
                        if (x2.fechaHasta) x2.fechaHasta = new Date(x2.fechaHasta);
                    });
                });
                data.recargosDescuentos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                    if (x.fechaOtorgamiento) x.fechaOtorgamiento = new Date(x.fechaOtorgamiento);
                });
                data.debitosAutomaticos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setPendingChange(false);
                inmueble_formSet({
                    idEstadoCarga: data.inmueble.idEstadoCarga,
                    catastralCir: data.inmueble.catastralCir,
                    catastralSec: data.inmueble.catastralSec,
                    catastralChacra: data.inmueble.catastralChacra,
                    catastralLchacra: data.inmueble.catastralLchacra,
                    catastralQuinta: data.inmueble.catastralQuinta,
                    catastralLquinta: data.inmueble.catastralLquinta,
                    catastralFrac: data.inmueble.catastralFrac,
                    catastralLfrac: data.inmueble.catastralLfrac,
                    catastralManz: data.inmueble.catastralManz,
                    catastralLmanz: data.inmueble.catastralLmanz,
                    catastralParc: data.inmueble.catastralParc,
                    catastralLparc: data.inmueble.catastralLparc,
                    catastralSubparc: data.inmueble.catastralSubparc,
                    catastralUfunc: data.inmueble.catastralUfunc,
                    catastralUcomp: data.inmueble.catastralUcomp,
                    catastralRtasPrv: data.inmueble.catastralRtasPrv,
                    tributoManz: data.inmueble.tributoManz,
                    tributoLote: data.inmueble.tributoLote,
                    tributoEsquina: data.inmueble.tributoEsquina,
                    catastralCodigo: data.inmueble.catastralCodigo,
                    catastralPartido: data.inmueble.catastralPartido

                });
                cuenta_formSet({
                    numeroCuenta: data.cuenta.numeroCuenta,
                    numeroWeb: data.cuenta.numeroWeb
                });
                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: data.archivos,
                    Observacion: data.observaciones,
                    Etiqueta: data.etiquetas
                }));
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };
    //#endregion

    //#region Funciones
    function getErrors() {
        const errors = {};

        if (inmueble_formValues.idEstadoCarga === 0) errors.idEstadoCarga = VALIDATION_MESSAGE.REQUIRED_SHORT;

        return errors;
    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs
        let entity = CloneObject(state.entity);

        UpdateEntityRow(typeEntity, row, entity);

        setState(prevState => {
            return {...prevState, entity: entity};
        });
        setPendingChange(true);
    }

    function ModifyBajaCuenta(idCuenta) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La cuenta fue dada de baja correctamente", () => {
                        dispatch(dataTaggerActionClear(state.processKey));
                        setState(prevState => {
                            return {...prevState, loading: false};
                        });
                        allowNavigation();
                        navigate({
                            to: `/inmueble/${OPERATION_MODE.VIEW}/${row.idTributo}`,
                            refresh: true,
                            replace: true,
                        })
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const paramsUrl = `/baja/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CUENTA,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }


    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    function ShowPopupMenu(menu) {
        let menues = CloneObject(menuesInit);
        menues[menu] = true;
        setState(prevState => {
            return {...prevState, showMenu: true, menues: menues};
        });
    }

    function HidePopupMenu() {
        setState(prevState => {
            return {...prevState, showMenu: false, menues: menuesInit};
        });
    }

    function ShowPage(partialUrl) {
        const url = APPCONFIG.SITE.WEBAPP + partialUrl + '/' + state.mode + '/' + state.entity.cuenta.id;
        window.open(url, '_blank');
    }

    // La ficha sale completa y sin diálogo de opciones (contrato del Epic LAR-2347),
    // así que el menú la descarga directo en vez de abrir un modal.
    const [generateFicha, ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer)
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    function refetchInmueble() {
        setState(x => ({...x, loading: true}))
        setTimeout(() => {
            FindInmueble(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindInmueble)
        }, 2000)
    }

    //#endregion

    const listMenu = [

        {
            menu: '1', items: [
                {
                    title: 'Obras', icon: 'apartment', onClick: () => {
                        ShowPopupMenu('obras')
                    }
                },
                {
                    title: 'Expedientes', icon: 'draft', onClick: () => {
                        ShowPopupMenu('expedientes')
                    }
                },
                {
                    title: 'Ficha del inmueble', icon: 'description', onClick: () => {
                        generateFicha('CuentaFicha', {idCuenta: state.entity.cuenta.id})
                    }
                }
            ]
        },

        {
            menu: '2', items: [
                {
                    title: 'Gestión', icon: 'gavel', items: [
                        {
                            title: 'Certificados escribanos', onClick: () => {
                                ShowPopupMenu('certificadosEscribanos')
                            }
                        },
                        {
                            title: 'Relaciones', onClick: () => {
                                ShowPopupMenu('relacionesCuentas')
                            }
                        },
                        {
                            title: 'Controladores', onClick: () => {
                                ShowPopupMenu('controladoresCuentas')
                            }
                        },
                        {
                            title: 'Zonas entregas', onClick: () => {
                                ShowPopupMenu('zonasEntrega')
                            }
                        },
                        {
                            title: 'Valuaciones', onClick: () => {
                                ShowPopupMenu('valuaciones')
                            }
                        },
                        {
                            title: 'EDE', onClick: () => {
                                ShowPopupMenu('edesur')
                            }
                        },
                        {
                            title: 'Catastro (ARBA)', onClick: () => {
                                ShowPopupMenu('catastro')
                            }
                        }
                    ]
                },
                {
                    title: 'Movimientos', icon: 'calculate', items: [
                        {
                            title: 'Cuenta corriente', onClick: () => {
                                ShowPage('cuenta-corriente/cuenta')
                            }, permisos: [PERMISSIONS.CUENTA_CORRIENTE_VIEW]
                        },
                        {
                            title: 'Créditos', onClick: () => {
                                ShowPopupMenu('aplicacionCreditos')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT, PERMISSIONS.CREDITO_EDIT]
                        },
                        {
                            title: 'Condonaciones', onClick: () => {
                                ShowPopupMenu('condonacion')
                            }, permisos: [PERMISSIONS.CONDONACION_EDIT]
                        },
                        {
                            title: 'Deuda', onClick: () => {
                                ShowPage('deuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Planes de pago', onClick: () => {
                                ShowPopupMenu('planesPago')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Liquidaciones', onClick: () => {
                                ShowPopupMenu('liquidaciones')
                            }, permisos: [PERMISSIONS.EMISION_EDIT, PERMISSIONS.LIQUIDACION_VIEW]
                        },
                        {
                            // pago-derecho-especial/:idCuenta no sigue el esquema de ShowPage (partialUrl/mode/id), por eso usamos window.open directo.
                            title: 'Derechos especiales', onClick: () => {
                                window.open(`${APPCONFIG.SITE.WEBAPP}pago-derecho-especial/${state.entity.cuenta.id}`, '_blank')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT]
                        },
                        {
                            title: 'Informe de deuda', onClick: () => {
                                ShowPopupMenu('informeDeuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        }
                    ]
                }
            ]
        },

    ];

    // El alta es por modal desde la grilla; /inmueble/new queda obsoleta.
    if (state.mode === OPERATION_MODE.NEW) return <Navigate to={'/inmuebles' + location.search} replace />;

    return (
        <>

            <Loading visible={state.loading}></Loading>

            {message.show &&
                <MessageModal
                    title={"Confirmación"}
                    message={message.text}
                    onDismiss={() => {
                        setMessage({show: false, text: "", callback: null, id: 0});
                    }}
                    onConfirm={() => {
                        if (message.callback) {
                            message.callback(message.id);
                        }
                        setMessage({show: false, text: "", callback: null, id: 0});
                    }}
                />
            }

            {state.showMenu &&
                <MenuLateral
                    state={state}
                    listExpedientes={listExpedientes}
                    listDireccionesRelacionadas={listDireccionesRelacionadas}
                    UpdateEntity={UpdateEntity}
                    HidePopupMenu={HidePopupMenu}
                    inmueble_formValues={inmueble_formValues}
                />
            }

            <div className='section-frames'>

                <div className='section-sidebar-left'>
                    <SectionSidebar
                        collapsed={toggledSidebarLeft}
                        listMenu={listMenu}
                    />
                </div>

                <div className='section-main'>

                    <SectionHeading
                        handleToggleSidebar={(state.mode !== OPERATION_MODE.NEW) ? () => {
                            setToggledSidebarLeft(prevState => !prevState)
                        } : null}
                        isSidebarOpen={!toggledSidebarLeft}
                        titles={[
                            {title: 'Tributos'},
                            {title: 'Administración de inmuebles', url: '/inmuebles'},
                            {title: params.mode === OPERATION_MODE.NEW ? 'Nuevo' : `Número de cuenta: ${cuenta_formValues.numeroCuenta}`}
                        ]}
                    />

                    <SectionForm
                        SetTabActive={SetTabActive}
                        pendingChange={pendingChange}
                        setPendingChange={setPendingChange}
                        state={state}
                        inmueble_formValues={inmueble_formValues}
                        inmueble_formSet={inmueble_formSet}
                        inmueble_formHandleProxy={inmueble_formHandleProxy}
                        cuenta_formValues={cuenta_formValues}
                        cuenta_formHandleProxy={cuenta_formHandleProxy}
                        UpdateEntity={UpdateEntity}
                        handleClickBaja={handleClickBaja}
                        refetchInmueble={refetchInmueble}
                        errorOf={errorOf}
                        estadoOpen={estadoOpen}
                        setEstadoOpen={setEstadoOpen}
                    />

                </div>

            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <FooterButtonVolver pendingChange={pendingChange} processKey={state.processKey}
                                        filters={previousFilters} to="/inmuebles"
                                        allowNavigation={allowNavigation}/>
                    {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                        <button className="btn action-button float-start m-left-20"
                                onClick={(event) => handleClickBaja()}>Baja</button>
                    }
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <button
                            className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                            onClick={(event) => handleClickGuardar()}
                            disabled={!pendingChange}
                        >
                            {(state.mode === OPERATION_MODE.NEW) ? "Siguiente" : "Guardar"}
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default InmuebleView;
